import { render } from "./OrderPartBillDetail.vue?vue&type=template&id=4b15af12&scoped=true&ts=true"
import script from "./OrderPartBillDetail.vue?vue&type=script&lang=ts"
export * from "./OrderPartBillDetail.vue?vue&type=script&lang=ts"

import "./OrderPartBillDetail.vue?vue&type=style&index=0&id=4b15af12&lang=sass&scoped=true"
import "./OrderPartBillDetail.vue?vue&type=style&index=1&id=4b15af12&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b15af12"]])

export default __exports__